import React from 'react'
import { Collapse } from 'react-collapse'
import PropTypes from 'prop-types'

export const disclaimerContents = {}

const getDisclaimerContent = (lenderName) => disclaimerContents[lenderName]

const DisclaimerContent = ({ className = '', lenderName, isOpen }) => (
  <div className={className}>
    <Collapse isOpened={isOpen}>
      <p className="mt-16 bodySmall">{getDisclaimerContent(lenderName)}</p>
    </Collapse>
  </div>
)

DisclaimerContent.propTypes = {
  className: PropTypes.string,
  lenderName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
}

export default DisclaimerContent
